'use strict';

var constants = require('../../../_virtual/constants.js_commonjs-exports2.js');

Object.defineProperty(constants.__exports, "__esModule", {
  value: true
});
constants.__exports.CHANNEL = '__direction__';

constants.__exports.DIRECTIONS = {
  LTR: 'ltr',
  RTL: 'rtl'
};

module.exports = constants.__exports;
